export const topbarTranslations = {
    en: {
        appTitle: "Chief Minister's Community Health Camp",
        appSubtitle: "Plan, manage, and track health campaigns with ease.",
        viewProfile: "View Profile",
        adminSupport: "Admin Support",
        featureComingSoon: "Feature coming soon. Stay tuned!",
        languageChanged: "Language changed to English",
    },
    mr: {
        appTitle: "मुख्यमंत्री सामुदायिक आरोग्य शिबिर",
        appSubtitle: "आरोग्य मोहिमा सहजपणे योजना करा, व्यवस्थापित करा आणि ट्रॅक करा.",
        viewProfile: "प्रोफाइल पहा",
        adminSupport: "प्रशासक समर्थन",
        featureComingSoon: "वैशिष्ट्य लवकरच येत आहे. संपर्कात रहा!",
        languageChanged: "भाषा मराठीमध्ये बदलली",
    }
};
